import React from "react";

// import statenames from "../data/state_abbrev_to_name.json";
import AK from "../img/svg/AK.svg";
import AL from "../img/svg/AL.svg";
import AR from "../img/svg/AR.svg";
import AZ from "../img/svg/AZ.svg";
import CA from "../img/svg/CA.svg";
import CO from "../img/svg/CO.svg";
import CT from "../img/svg/CT.svg";
import DE from "../img/svg/DE.svg";
import FL from "../img/svg/FL.svg";
import GA from "../img/svg/GA.svg";
import HI from "../img/svg/HI.svg";
import IA from "../img/svg/IA.svg";
import ID from "../img/svg/ID.svg";
import IL from "../img/svg/IL.svg";
import IN from "../img/svg/IN.svg";
import KS from "../img/svg/KS.svg";
import KY from "../img/svg/KY.svg";
import LA from "../img/svg/LA.svg";
import MA from "../img/svg/MA.svg";
import MD from "../img/svg/MD.svg";
import ME from "../img/svg/ME.svg";
import MI from "../img/svg/MI.svg";
import MN from "../img/svg/MN.svg";
import MO from "../img/svg/MO.svg";
import MS from "../img/svg/MS.svg";
import MT from "../img/svg/MT.svg";
import NC from "../img/svg/NC.svg";
import ND from "../img/svg/ND.svg";
import NE from "../img/svg/NE.svg";
import NH from "../img/svg/NH.svg";
import NJ from "../img/svg/NJ.svg";
import NM from "../img/svg/NM.svg";
import NV from "../img/svg/NV.svg";
import NY from "../img/svg/NY.svg";
import OH from "../img/svg/OH.svg";
import OK from "../img/svg/OK.svg";
import OR from "../img/svg/OR.svg";
import PA from "../img/svg/PA.svg";
import RI from "../img/svg/RI.svg";
import SC from "../img/svg/SC.svg";
import SD from "../img/svg/SD.svg";
import TN from "../img/svg/TN.svg";
import TX from "../img/svg/TX.svg";
import UT from "../img/svg/UT.svg";
import VA from "../img/svg/VA.svg";
import VT from "../img/svg/VT.svg";
import WA from "../img/svg/WA.svg";
import WI from "../img/svg/WI.svg";
import WV from "../img/svg/WV.svg";
import WY from "../img/svg/WY.svg";

import '../styles/state-map.css';

const StateMap = props => {
  const renderSvg = (stateName) => {
    const svgStyle = {
      width: '100%',
      maxHeight: '100%'
    };
    
    switch(stateName) {
      case "AK":
        return <AK style={svgStyle} />;
      case "AL":
        return <AL style={svgStyle} />;
      case "AR":
        return <AR style={svgStyle} />;
      case "AZ":
        return <AZ style={svgStyle} />;
      case "CA":
        return <CA style={svgStyle} />;
      case "CO":
        return <CO style={svgStyle} />;
      case "CT":
        return <CT style={svgStyle} />;
      case "DE":
        return <DE style={svgStyle} />;
      case "FL":
        return <FL style={svgStyle} />;
      case "GA":
        return <GA style={svgStyle} />;
      case "HI":
        return <HI style={svgStyle} />;
      case "IA":
        return <IA style={svgStyle} />;
      case "ID":
        return <ID style={svgStyle} />;
      case "IL":
        return <IL style={svgStyle} />;
      case "IN":
        return <IN style={svgStyle} />;
      case "KS":
        return <KS style={svgStyle} />;
      case "KY":
        return <KY style={svgStyle} />;
      case "LA":
        return <LA style={svgStyle} />;
      case "MA":
        return <MA style={svgStyle} />;
      case "MD":
        return <MD style={svgStyle} />;
      case "ME":
        return <ME style={svgStyle} />;
      case "MI":
        return <MI style={svgStyle} />;
      case "MN":
        return <MN style={svgStyle} />;
      case "MO":
        return <MO style={svgStyle} />;
      case "MS":
        return <MS style={svgStyle} />;
      case "MT":
        return <MT style={svgStyle} />;
      case "NC":
        return <NC style={svgStyle} />;
      case "ND":
        return <ND style={svgStyle} />;
      case "NE":
        return <NE style={svgStyle} />;
      case "NH":
        return <NH style={svgStyle} />;
      case "NJ":
        return <NJ style={svgStyle} />;
      case "NM":
        return <NM style={svgStyle} />;
      case "NV":
        return <NV style={svgStyle} />;
      case "NY":
        return <NY style={svgStyle} />;
      case "OH":
        return <OH style={svgStyle} />;
      case "OK":
        return <OK style={svgStyle} />;
      case "OR":
        return <OR style={svgStyle} />;
      case "PA":
        return <PA style={svgStyle} />;
      case "RI":
        return <RI style={svgStyle} />;
      case "SC":
        return <SC style={svgStyle} />;
      case "SD":
        return <SD style={svgStyle} />;
      case "TN":
        return <TN style={svgStyle} />;
      case "TX":
        return <TX style={svgStyle} />;
      case "UT":
        return <UT style={svgStyle} />;
      case "VA":
        return <VA style={svgStyle} />;
      case "VT":
        return <VT style={svgStyle} />;
      case "WA":
        return <WA style={svgStyle} />;
      case "WI":
        return <WI style={svgStyle} />;
      case "WV":
        return <WV style={svgStyle} />;
      case "WY":
        return <WY style={svgStyle} />;
      default:
        return;
    }
  }

  return (
    <div className="state-map">
      {renderSvg(props.stateName)}
    </div>
  );
};

export default StateMap;
